import {GetPluginMetaByID} from 'app/components/management/common/plugins/plugin-metadata';
import {BodyText, FlexRow} from '@make-software/cspr-design';
import React from 'react';

export const PluginChip = ({id}: {id: number}) => {
  const pluginMeta = GetPluginMetaByID(id);
  return (
    <FlexRow align={'center'} gap={4}>
      {pluginMeta.icon} <BodyText size={3}>{pluginMeta.name}</BodyText>
    </FlexRow>
  )
};